const BLUE_24 = "#41C5E5";
const YELLOW_24 = "#FFCB29";
const RED_24 = "#ED1D45";

export const BLUE_24_RGB = [65, 197, 229];

export const SUCCESS = "#6CCF1B";
export const ERROR = "#ED1D45";
export const WARNING = "#FF9900";

export const WHITE = "#FFFFFF";
export const BLACK = "#2A2A2A";

export const READY_TO_ASSIGN_COLOR = "#673AB7";

export const mainColors = {
  blue: BLUE_24,
  yellow: YELLOW_24,
  red: RED_24,
};

export const opacityVariables = {
  "high-emphasis-opacity": 0.98,
  "medium-emphasis-opacity": 0.95,
  "theme-overlay-multiplier": 0.1, // For SideNav selected item background
};

export const statusColors = {
  success: SUCCESS,
  "on-success": WHITE,
  "success-lighten": "#E8FFD7",
  "on-success-lighten": SUCCESS,
  warning: WARNING,
  "on-warning": BLACK,
  error: ERROR,
  "on-error": WHITE,
  "error-lighten": "#FEdADD",
  "on-error-lighten": ERROR,
  info: BLUE_24,
  "on-info": WHITE,
  "info-lighten": "#DDF3FA",
  "on-info-lighten": BLUE_24,
};

export const blueMainColors = {
  primary: BLUE_24,
  "primary-lighten": "#81D3E7",
  "on-primary": WHITE,
  secondary: YELLOW_24,
  "on-secondary": BLACK,
  tertiary: RED_24,
  "on-tertiary": WHITE,
};

export const yellowMainColors = {
  primary: YELLOW_24,
  "primary-lighten": "#FFDD76",
  "on-primary": BLACK,
  secondary: RED_24,
  "on-secondary": WHITE,
  tertiary: BLUE_24,
  "on-tertiary": WHITE,
};

export const redMainColors = {
  primary: RED_24,
  "primary-lighten": "#EA627D",
  "on-primary": WHITE,
  secondary: BLUE_24,
  "on-secondary": BLACK,
  tertiary: YELLOW_24,
  "on-tertiary": WHITE,
};
